import Top100Icon from '@/assets/svg/top100.svg?raw'

export default {
  name: 'top100-badge',
  data () {
    return {
      iconTop100: Top100Icon
    }
  }
}
